import { Box, IconButton, Typography, styled, useTheme } from "@mui/material";

import { Left } from "assets/Icon";

export function HeaderNotification({ onClose }) {
  const theme = useTheme();

  return (
    <>
      <BoxTitle mt={2}>
        <Typography variant="h6" color="text.main" textAlign="right">
          اعلانات
        </Typography>

        <IconButton color="text" aria-label="close" onClick={onClose}>
          <Left color={theme.palette.text.main} />
        </IconButton>
      </BoxTitle>
    </>
  );
}

const BoxTitle = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  svg: {
    fontSize: "16px",
  },
}));
export default HeaderNotification;
